var _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Service, { inject as service } from '@ember/service';
import $ from 'jquery';
import environment from '@square/environment-utils/environment';
const env = environment();
const PAYKIT_STAGING = 'https://kit.cashstaging.app/v1/pay.js';
const PAYKIT_PROD = 'https://kit.cash.app/v1/pay.js';
const payKitScriptSource = env.isProduction && PAYKIT_PROD || PAYKIT_STAGING;
const CLIENT_ID_STAGING = 'CA0-CI_SQUARE-BANKING';
const CLIENT_ID_PROD = 'CA-CI_SQUARE-BANKING';
const clientId = env.isProduction && CLIENT_ID_PROD || CLIENT_ID_STAGING;
// Pay Kit doc: https://developers.cash.app/docs/pay-kit-getting-started
let CashAppPayKitSdk = (_class = class CashAppPayKitSdk extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "sentry", _descriptor, this);
    _defineProperty(this, "restart", () => Promise.resolve());
  }
  async initialize({
    container,
    redirectURL,
    onSuccessCallback,
    onDismissCallback,
    onDeclineCallback,
    actionData,
    isMobileFlow
  }) {
    try {
      if (!window.CashApp?.pay) {
        // eslint-disable-next-line ember/no-jquery
        await $.getScript(payKitScriptSource);
      }
      const pay = await window.CashApp?.pay({
        clientId
      });

      // event listeners

      onDismissCallback && pay.addEventListener('CUSTOMER_DISMISSED', function _onDismissCallback() {
        onDismissCallback && onDismissCallback();
        pay.removeEventListener('CUSTOMER_DISMISSED', _onDismissCallback);
      });
      onDeclineCallback && pay.addEventListener('CUSTOMER_REQUEST_DECLINED', onDeclineCallback);
      onSuccessCallback && pay.addEventListener('CUSTOMER_REQUEST_APPROVED', result => {
        onSuccessCallback(result);
      });
      if (isMobileFlow) {
        return;
      }
      const controls = await this.render(pay, container, redirectURL, actionData);
      if (!controls.begin || !controls.restart) {
        throw new Error('Cash App Pay Kit: failed to load.');
      }
      this.restart = controls.restart;
      return controls;
    } catch (error) {
      this.sentry.captureException(error);
      return null;
    }
  }
  async render(pay, container, redirectURL, actionData) {
    const {
      begin
    } = await pay.render(container, {
      button: false,
      manage: false
    });
    await pay.customerRequest({
      actions: {
        deposits: {
          primaryAlias: actionData.primary_alias,
          logoURL: actionData.logo_url
        }
      },
      redirectURL,
      referenceId: `refId-${Date.now()}`
    });
    return {
      begin,
      restart: pay.restart
    };
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { CashAppPayKitSdk as default };